/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { DeleteOnboardingServiceApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteOnboardingService: build.mutation<unknown, DeleteOnboardingServiceApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/v1/onboarding/services/${queryArg.serviceId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as deleteOnboardingServiceApi };
export const { useDeleteOnboardingServiceMutation } = injectedRtkApi;
